module.exports = __webpack_public_path__ + "media/application/images/kids/kids-mascot-b24f38189f079956618c21d761cb5e31.png";